import { render, staticRenderFns } from "./paneldynamic-next-btn.vue?vue&type=template&id=6cc1c777&"
import script from "./paneldynamic-next-btn.vue?vue&type=script&lang=ts&"
export * from "./paneldynamic-next-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc1c777')) {
      api.createRecord('6cc1c777', component.options)
    } else {
      api.reload('6cc1c777', component.options)
    }
    module.hot.accept("./paneldynamic-next-btn.vue?vue&type=template&id=6cc1c777&", function () {
      api.rerender('6cc1c777', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/paneldynamic-actions/paneldynamic-next-btn.vue"
export default component.exports